import request from "../../config/axios";

const getLangAndCurrency = (lang = 'vi') => {
    return request.get(`/wp-json/custom-lang/v1/content/${lang}`)

}

export { getLangAndCurrency }
